export default __webpack_public_path__ + "static/media/usb.37a9ade3.svg";